module.exports = __webpack_public_path__ + "static/img/head-menu-bg-select-128.9acbf4d7.png";